import PATH from "constants/path";
import React from "react";
import { isAuthenticated } from "utils/common";
import {
  illust08,
  illust02,
  illust03,
  illust01,
  illust301,
  illust301_pc,
} from "assets/img";
import { ChevronRightBrown } from "assets/svg";

function First() {
  return (
    <div className={isAuthenticated() ? "w-80" : "clap container px-0"}>
      <div className="bg-yellow py-2 text-center position-relative sp-1 fw-600 z-index-2">
        <div className="fs-12 lh-21">＼番組観覧・イベント参加／</div>
        <div className="fs-20 fs-sm-18">はじめての方へ</div>
        <img
          className="position-absolute top-100 end-0 translate-middle-y img-w"
          src={illust01}
          alt={illust01}
        ></img>
      </div>

      <div className="px-3 px-md-5 py-4 text-md-center bg-brown">
        <div className="text-grey mt-3 mt-md-0 mb-3 sp-14 fw-600">
          「CLAP&WALK(クラップアンドウォーク)」とは
          <span className="text-brown text-decoration-underline">
            <a href="https://www.architect.co.jp/" target="_blank">
              株式会社アーキテクト
            </a>
          </span>
          が運営する
          <br className="hidebreak" />
          テレビ番組の観覧サイトです。
        </div>
        <div className="my-3">
          <img className="d-block d-md-none mx-auto" src={illust301} />
          <img className="d-none d-md-block" src={illust301_pc} />
        </div>

        <div className="list-first-step mt-3">
          <div className="step-item">
            <div className="title">
              <div>STEP1</div>
              <div className="sub-title">会員登録する</div>
              <div className="image">
                <img src={illust08} alt="illust08" />
              </div>
            </div>
            <div className="mt-3 mb-1 lh-21">
              お名前や生年月日などの会員情報を入力し、ご登録のメールアドレスに送付される確認メールのURLをクリックすると、会員登録が完了します。
            </div>
            {!isAuthenticated() && (
              <div className="more">
                <a href={PATH.COMMON + PATH.SIGNUP}>
                  会員登録
                  <span className="ms-2">
                    <ChevronRightBrown />
                  </span>
                </a>
              </div>
            )}

            <span className="triangle"></span>
          </div>
          <div className="step-item">
            <div className="title">
              <div>STEP2</div>
              <div className="sub-title">案件に参加する</div>
              <div className="image">
                <img src={illust02} alt="illust02" />
              </div>
            </div>
            <div className="mt-3 mb-1 lh-21">
              バラエティ番組や歌番組など番組観覧、CMやドラマ出演、映画試写会や音楽ライブイベント参加など多数の案件を掲載しています。
            </div>
            <div className="more">
              <a href={PATH.GUIDE}>
                ご利用方法
                <span className="ms-2">
                  <ChevronRightBrown />
                </span>
              </a>
            </div>
            <span className="triangle"></span>
          </div>
          <div className="step-item">
            <div className="title">
              <div>STEP3</div>
              <div className="sub-title">謝礼をゲット!</div>
              <div className="image">
                <img src={illust03} alt="illust03" />
              </div>
            </div>
            <div className="mt-3 mb-1 lh-21 sp-14">
              案件にご参加いただき達成条件を満たすとポイントが付与されます。毎月末に3,000ポイント超えた時点で自動的に登録口座へお振込しますので、奮ってお気軽にご参加ください。
            </div>
            <div className="more">
              <a href={PATH.POINT}>
                ポイントについて
                <span className="ms-2">
                  <ChevronRightBrown />
                </span>
              </a>
            </div>
            <span className="triangle"></span>
          </div>
        </div>

        <div className="w-question mt-5 mb-3">
          <a href={PATH.QUESTIONS}>
            <span className="me-3 fs-icon">
              <i className="bi bi-question-circle-fill"></i>
            </span>
            よくあるご質問
          </a>
        </div>
      </div>
    </div>
  );
}

export default First;
